import axios from 'axios';
import AuthService from "./authService";
import { fireUnauthorized } from './authEvents';

// Create axios instance with default configuration
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8007',
    timeout: 45000, // Increased to 45 seconds - financial analytics queries can be slow
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add token to headers
api.interceptors.request.use(
    (config) => {
        const token = AuthService.getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response interceptor for auth error handling
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const status = error.response?.status;
        // 401 = invalid/expired token; 403 = token rejected by server after restart
        if (status === 401 || status === 403) {
            AuthService.removeToken();
            fireUnauthorized();
        }
        return Promise.reject(error);
    }
);

export { api };
export default api;